import React from 'react';

import { observer } from 'mobx-react';

import { VatixCard } from 'components/KnockGuidesProvider/VatixGuides';
import Record from 'ui/Record/Record';

import { useNavBarHeight } from 'utils/hooks/navbar';
import { useStore } from 'utils/hooks/store';
import { UserLicensesResponse } from 'utils/api/modules/user/user.types';

import { HomeHeader } from './styles';
import TasksPane from './panes/TasksPane';
import SolutionsPane from './panes/SolutionsPane';
import AlarmsPane from './panes/AlarmsPane';

enum AccessiblePanes {
  MyTasks,
  Alarms,
}

const getAccessiblePanes = (licenses?: UserLicensesResponse): AccessiblePanes[] => {
  const accessiblePanes = [];
  if (licenses) {
    if (licenses.workflows || licenses.events || licenses.documents) {
      accessiblePanes.push(AccessiblePanes.MyTasks);
    }

    if (licenses.protectorAlarms) {
      accessiblePanes.push(AccessiblePanes.Alarms);
    }
  }
  return accessiblePanes;
};

interface HomeContentProps {
  accessiblePanes: AccessiblePanes[];
}

const HomeContent: React.FunctionComponent<HomeContentProps> = ({ accessiblePanes }) => {
  const { home } = useStore();

  React.useEffect(() => {
    if (home.content === undefined && !home.hasError) {
      home.loadHomeContent();
    }
  }, [home]);

  return (
    <>
      <VatixCard />
      {accessiblePanes.includes(AccessiblePanes.MyTasks) ? <TasksPane aria-label="tasks pane" /> : null}
      {accessiblePanes.includes(AccessiblePanes.Alarms) ? <AlarmsPane aria-label="alarms pane" /> : null}
      <SolutionsPane aria-label="solutions pane" />
    </>
  );
};

const Home: React.FunctionComponent = () => {
  const navBarHeight = useNavBarHeight();
  const {
    session: { user },
  } = useStore();

  const accessiblePanes = getAccessiblePanes(user?.licenses);

  return (
    <Record
      Header={
        <HomeHeader title={`Welcome back, ${user?.name || user?.email}!`} documentTitle="Home" breadcrumbs={[]} />
      }
      Content={() => <HomeContent accessiblePanes={accessiblePanes} />}
      navBarHeight={navBarHeight}
    />
  );
};

export default observer(Home);
